import React from 'react';
import { Route } from 'react-router-dom';
import { makeStyles, Card, CardContent, CardActions, Button } from '@material-ui/core';

import { mainStyles } from '../../shared/styles/common';

const useStyles = makeStyles({
  cardRow: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  onboardingCard: {
    marginRight: '20px',
    maxWidth: '350px',
    display: 'grid',
    gridTemplateAreas: `
      'image'
      'desc'
      'action'
`,
    gridTemplateRows: 'auto 30% 15%',
    rowGap: '1px',
    '& .logoPic': {
      gridArea: 'image',
      alignSelf: 'center',
      padding: '10px',
      maxWidth: '330px',
    },
    '& .desc': {
      gridArea: 'desc',
    },
    '& .action': {
      gridArea: 'action',
    },
  },
});

const Onboarding: React.FC = () => {
  const classes = { ...mainStyles(), ...useStyles() };

  return (
    <div>
      <Route
        exact
        path="/onboarding"
        render={() => (
          <div className={classes.container}>
            <div className={classes.cardRow}>
              <Card className={classes.onboardingCard}>
                <img
                  className="logoPic"
                  src="https://res.cloudinary.com/dsw5m2dqw/image/upload/v1607523946/assets/prometheus_yomm6a.png"
                  alt="Prometheus"
                />
                <CardContent className="desc">Onboard metrics using Prometheus</CardContent>
                <CardActions className="action">
                  <Button
                    size="small"
                    color="primary"
                    component="a"
                    href="https://docs.adeptdc.com/"
                    target="_blank"
                    rel="noopener"
                  >
                    Get Started
                  </Button>
                </CardActions>
              </Card>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default Onboarding;
